export default __webpack_public_path__ + "static/media/interaction.e2064d22.webp";